export const CloseMethodName = "T42.WordEditor.Closed";
export const EditHtmlMethodName = "T42.Word.HtmlEdit";
export const ReceiveHtmlMethodName = "T42.Word.HtmlReceive";
export const ReturnHtmlMethodName = "T42.Word.ReturnHtml";
export const OnReturnHtmlMethodName = "T42.Word.OnReturnHtml";
export const ChunkSize = 4000000;
